import {Component, Input, OnChanges, OnDestroy, SimpleChanges} from '@angular/core';
import {CommonModule} from "@angular/common";
import {
  TagGetAllByEntityTypeAndEntityIdActionService
} from "../../service/tagGetAllByEntityTypeAndEntityIdAction.service";
import {LoadingModule} from "../../../../../../components/common/loading/loading.module";
import {ServiceContainerComponent} from "../../../../../core/component/service-container/service-container.component";
import {MatTooltipModule} from "@angular/material/tooltip";
import {ButtonModule} from "../../../../../core/component/button/button.module";
import {TagFieldComponent} from "../tag-field/tag-field.component";
import {DialogController} from "../../../../dialog/dialogController";
import {TagsEditDialogComponent, TagsEditDialogInput} from "../tags-edit-dialog/tags-edit-dialog.component";
import {TagSummaryModel} from "../../model/tagSummary.model";
import {Subscription} from "rxjs";
import {TagRepository} from "../../../impl/service/ngrx/tag.repository";

@Component({
  selector: 'app-tags-summary-field',
  templateUrl: './tags-summary-field.component.html',
  standalone: true,
  imports: [
    CommonModule,
    LoadingModule,
    ServiceContainerComponent,
    MatTooltipModule,
    ButtonModule,
    TagFieldComponent,
    TagsEditDialogComponent,
  ],
  providers: [
    TagGetAllByEntityTypeAndEntityIdActionService
  ]
})
export class TagsSummaryFieldComponent implements OnChanges, OnDestroy {
  @Input() entityType: string;
  @Input() entityId: number;

  subscriptions: Subscription[] = [];
  tags: TagSummaryModel[] = [];

  constructor(public service: TagGetAllByEntityTypeAndEntityIdActionService,
              public dialogController: DialogController,
              private tagRepository: TagRepository) {
    this.subscriptions.push(this.service.result$.subscribe(value => this.tags = value));
    this.subscriptions.push(this.tagRepository.changed$.subscribe(() => this.refresh()))
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['entityType'] || changes['entityId']) {
      if (this.entityType && this.entityId) {
        this.refresh();
      }
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  refresh() {
    this.service.executeAction({
      entityId: this.entityId,
      entityTypeValue: this.entityType
    });
  }

  open() {
    const input: TagsEditDialogInput = {
      tags: this.tags,
      entityTypeValue: this.entityType,
      entityId: this.entityId
    }
    this.dialogController.open(TagsEditDialogComponent, input, {
      title: 'Modifier les étiquettes',
      width: '500px'
    }).afterClosed()
        .toPromise()
        .then(() => {
          this.refresh();
        });
  }


}
